import { Text } from '@thefarmersfront/kitchen';

import styles from './ResultStatusSummary.module.scss';

const ResultStatusSummary = ({
  totalCount,
  successCount,
  failCount,
}: {
  totalCount: number;
  successCount: number;
  failCount: number;
}) => {
  return (
    <div className={styles['summary-container']}>
      <div className={styles['summary-item']}>
        <Text color="secondary" element="span">
          전체
        </Text>
        <Text weight="semi-bold" element="span">
          {totalCount ?? '-'}
        </Text>
      </div>
      <div className={styles['summary-item']}>
        <Text color="secondary" element="span">
          성공
        </Text>
        {successCount ? (
          <Text color="success" weight="semi-bold" element="span">
            {successCount}
          </Text>
        ) : (
          <Text weight="semi-bold" element="span">
            {'-'}
          </Text>
        )}
      </div>
      <div className={styles['summary-item']}>
        <Text color="secondary" element="span">
          실패
        </Text>
        {failCount ? (
          <Text color="error" weight="semi-bold" element="span">
            {failCount}
          </Text>
        ) : (
          <Text weight="semi-bold" element="span">
            {'-'}
          </Text>
        )}
      </div>
    </div>
  );
};

export default ResultStatusSummary;
